import { Injectable } from '@angular/core';
import { teacherNavigationConfigs } from '@services/navigation/teacher-navigation-configs';

import { NavigationService } from './navigation.service';

@Injectable()
export class TeacherNavigationService extends NavigationService {
  navigationConfigs = teacherNavigationConfigs;
}
